import { Component, ElementRef } from "@angular/core";
import { FloatUIService } from "../services/floatui.service";

@Component({
    selector: 'shared-floatui-display',
    templateUrl: './floatui-display.component.html',
    styleUrls: ['./floatui-display.component.scss'],
    standalone: false,
})
export class FloatuiDisplayComponent {

    constructor(
        floatUIService: FloatUIService,
        private elementRef: ElementRef<HTMLElement>
    ) {
        floatUIService.registerRootComponent(this);
    }
    
    createComponent(element: HTMLElement): void {
        this.elementRef.nativeElement.appendChild(element);
    }

    destroyComponent(element: HTMLElement): void {
        this.elementRef.nativeElement.removeChild(element);
    }
}